// Add this code to your JavaScript file or <script> tag
document.addEventListener('DOMContentLoaded', function() {
    const isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
    const isThemeEditor = window.Shopify && window.Shopify.designMode;
    if (isMobileViewport || isThemeEditor) {
        return;
    }

    const items = document.querySelectorAll('.collection-grid .item');
    
    // Set initial state - completely handled by JS
    items.forEach(item => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(50px)';
        item.style.transition = 'none'; // No transition initially
    });
    
    // Intersection Observer for scroll detection
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -100px 0px', // Adjust this to trigger animation earlier
        threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                // Calculate delay based on position in viewport
                const delay = Math.min(index * 120, 800); // Max 800ms delay
                
                // Apply animation with delay
                setTimeout(() => {
                    entry.target.style.transition = 'opacity 0.7s ease-out, transform 0.7s ease-out';
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                    
                    // Optional: Mark as animated
                    entry.target.classList.add('animated');
                }, delay);
                
                // Stop observing this item
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    
    // Start observing all items
    items.forEach(item => observer.observe(item));
    
    // Optional: Trigger animation on page load for items already in viewport
    setTimeout(() => {
        items.forEach((item, index) => {
            const rect = item.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            
            if (isVisible && !item.classList.contains('animated')) {
                const delay = Math.min(index * 120, 800);
                setTimeout(() => {
                    item.style.transition = 'opacity 0.7s ease-out, transform 0.7s ease-out';
                    item.style.opacity = '1';
                    item.style.transform = 'translateY(0)';
                    item.classList.add('animated');
                }, delay);
            }
        });
    }, 100);
});
